
App.AccountPhotoComponent = Em.Component.extend
  classNames: [ 'account-photo' ]

  fileInput: null
  isUploading: false


  actions:
    openDialog: ->
      @get('fileInput')?.send('openDialog')
      false

    uploadPhoto: (file) ->
      account = @get('account')

      @set('isUploading', true)
      account.uploadAvatar(file)
      .then =>
        account.reload()
        .finally =>
          @set('isUploading', false)
      false

